import { DataTableColumnHeader } from "components/ui/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import {
  DataTableActions,
  IDataTableAction,
} from "components/ui/DataTableActions";

import { IHubVehicle } from "interfaces/Hub";
import { usePermissions } from "hooks";

interface IColumnProps {
  deleteFunc: (toDelete: IHubVehicle) => void;
}

export function useColumns({ deleteFunc }: IColumnProps) {
  const { checkUserPermission } = usePermissions();

  const columns: ColumnDef<IHubVehicle>[] = [
    {
      id: "Id",
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Id" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.id}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "renavam",
      accessorKey: "renavam",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Renavam" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.renavam}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "vehicle_plate",
      accessorKey: "vehicle_plate",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Placa" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.vehicle_plate}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "vehicle_type",
      accessorKey: "vehicle_type",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Tipo" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.vehicleType.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "vehicleSubtype",
      accessorKey: "vehicleSubtype",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Subtipo" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.vehicleSubtype.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "brand",
      accessorKey: "brand",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Marca" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.brand.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "model",
      accessorKey: "model",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Modelo" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.model.name}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "manufacture_year",
      accessorKey: "manufacture_year",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Ano" />
      ),
      cell: ({ row: { original: data } }) => {
        return `${data.manufacture_year}`;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "carrier",
      accessorKey: "carrier",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Transportadora" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.carriers.length ? data.carriers[0].company_name : "";
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "actions",
      cell: ({ row: { original: data } }) => {
        const actions: IDataTableAction[] = [
          {
            name: "Editar",
            route: `/settings/hub-vehicles/edit/${data.id}`,
            hasPermission: checkUserPermission("all"),
          },
          {
            name: "Excluir",
            action: () => deleteFunc(data),
            hasPermission: checkUserPermission("all"),
          },
        ];
        return <DataTableActions actions={actions} />;
      },
    },
  ];

  return { columns };
}
